import { render, staticRenderFns } from "./deviceMonitor.vue?vue&type=template&id=4deb844c&scoped=true"
import script from "./deviceMonitor.vue?vue&type=script&lang=js"
export * from "./deviceMonitor.vue?vue&type=script&lang=js"
import style0 from "./deviceMonitor.vue?vue&type=style&index=0&id=4deb844c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4deb844c",
  null
  
)

export default component.exports